module.exports = __webpack_public_path__ + "img/1390944329.dd4de707.jpg";